import React, {  } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { StyledComponentProps } from '@material-ui/core/styles';
import DeleteButton from '../Button/DeleteButton';
import UndoButton from '../Button/UndoButton';
import { withStyles, Typography } from '@material-ui/core';
import { styles } from './styles';
import SendButton from '../Button/SendButton';
import { WithMediaQuery, IMediaQueryProps } from '../../layout/withMediaQuery';

interface IProps extends StyledComponentProps, IMediaQueryProps {
    onConfirm: () => any;
    onCancel: () => any;
    children?: any;
    confirmText: string;
    cancelText: string;
    icon: 'publish' | 'delete';
    title?: string;
    text: string;
    open: boolean;
}


const Prompt = (props: IProps) => {

    const OkIconButton = () => {
        if (props.icon === 'delete')
            return <DeleteButton onClick={props.onConfirm} text={props.confirmText} />
        return <SendButton onClick={props.onConfirm} text={props.confirmText} />
    }
    
    const UndoIconButton = () => {
        return <UndoButton onClick={props.onCancel} text={props.cancelText} />
    }
    
    return (

        <Dialog
            open={props.open}
            onClose={(e) => props.onCancel()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            {props.title && <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>}
            <DialogContent className={props.smallScreen ?props.classes.smallcontent : props.classes.content}>
                <Typography variant='h5'>{props.text}</Typography>
            </DialogContent>
            <DialogActions className={props.classes.actions}>
                <OkIconButton />
                <UndoIconButton />
            </DialogActions>
        </Dialog>
    );
}

export default withStyles(styles)(WithMediaQuery(Prompt));